import { graphql } from '../../../../graphql/generated';

export const CREATE_SPECIAL_RATE_MUTATION = graphql(`
  mutation CreateSpecialRate($input: SpecialRateCreateInput!) {
    createSpecialRate(input: $input) {
      id
    }
  }
`);
